export default __webpack_public_path__ + "static/media/invites.c98c68ba.webp";